import React from "react"
import styled from "styled-components"
import { fontRegular, fontSemiBold } from "../../utils/fontFamily"

export const UnorderedList = styled.ul`
  margin: 0 0 20px 0;
  padding: 0;
`

export const ListItem = styled.li`
  display: flex;
  list-style-type: none;
  align-items: center;
  ${fontRegular()};
  color: #555;
  margin-bottom: 5px;
  img {
    margin-bottom: 0;
  }
  p {
    text-align: left;
  }
`

const ComingSoonText = styled.p`
  ${fontSemiBold()}
  color: #fff;
  background-color: #bc5de8;
  margin-bottom: 0;
  font-size: 12px;
  padding: 3px 10px;
  border-radius: 50px;
  margin-left: 10px;
`

export const ComingSoonLabel = () => <ComingSoonText>Coming</ComingSoonText>
